import React, { PureComponent } from 'react';
import { Container, Form, InputGroup, Label, Row } from 'reactstrap';
import { Field } from 'redux-form';
import { connect } from 'react-redux';
import cx from 'classnames';
import { compact } from 'underscore';

// ducks
import { fetchCategory as load } from '../../../ducks/AgentSearch';

// components
import BufferedInput from '../../../components/form/field/buffered-input';
import FirmTypeAhead from '../../../components/form/field/firm-typeahead';
import Filter from '../../../components/form/filter';

// decorators
import fieldButtonDropdown from '../../../decorators/field-button-dropdown';

// modules
import BS from '../../../theme/Bootstrap';
import styles from '../../Containers.module.scss';

const FilterDropdown = fieldButtonDropdown(Filter);

class ServiceProviderSearch extends PureComponent {
  render() {
    const { handleSubmit, categories } = this.props;
    return (
      <Row className={cx(styles.searchHeader, BS.pt3)}>
        <Container>
          <Form inline className={BS.alignItemsStart} onSubmit={handleSubmit}>
            {this.props.children}
            <InputGroup className={cx(BS.inputGroupGutter, BS.pb2, BS.mrSm2)}>
              <Label for="name" className="sr-only">
                Name
              </Label>
              <Field
                name="name"
                type="text"
                placeholder="Name"
                component={BufferedInput}
                showSubmit
                submitClassName={cx(BS.ml2, BS.dMdNone)}
              />
            </InputGroup>
            <InputGroup className={cx(BS.inputGroupGutter, BS.pb2, BS.mrSm2)}>
              <Label for="firm" className="sr-only">
                Name
              </Label>
              <Field
                name="firm"
                type="text"
                placeholder="Firm Name"
                component={FirmTypeAhead}
                officeType="service_company"
                showSubmit
                submitClassName={cx(BS.ml2)}
              />
            </InputGroup>
            <InputGroup className={cx(BS.inputGroupGutter, BS.dNone, BS.dSmFlex, BS.pb2)}>
              <Field
                name="categoryId"
                component={FilterDropdown}
                label="Category"
                items={categories}
                renderType="checkbox"
                numCols={1}
                format={value => {
                  return compact((value || '').trim().split(',')).map(val =>
                    parseInt(val, 10)
                  );
                }}
                normalize={value => {
                  return value.join(',');
                }}
              />
            </InputGroup>
          </Form>
        </Container>
      </Row>
    );
  }
  componentDidMount() {
    this.checkAndLoad();
  }

  componentDidUpdate() {
    this.checkAndLoad();
  }

  checkAndLoad() {
    const { loaded, isLoading, error, load } = this.props;
    if (!loaded && !isLoading && !error) {
      load();
    }
  }
}

export default connect(
  (state, props) => ({
    categories: state.AgentSearch.getIn(['category', 'results']).toJS(),
    loaded: state.AgentSearch.getIn(['category', 'loaded']),
    isLoading: state.AgentSearch.getIn(['category', 'loading']),
    error: state.AgentSearch.getIn(['category', 'error'])
  }),
  {
    load
  }
)(ServiceProviderSearch);



// WEBPACK FOOTER //
// ./src/containers/AgentSearch/Search/ServiceProviderSearch.js